import gql from 'graphql-tag';
const OBJECT_IN_A_SENTENCE_ACTIVITY_FRAGMENT = gql `
  fragment ObjectInASentenceActivityFragment on ObjectInASentenceActivity {
    rounds {
      id
      text
      punctuation
      answers {
        id
        answer
        answerImage {
          id
          image {
            description
            id
            src
          }
        }
        answerAudio {
          id
          audio {
            id
            src
          }
        }
      }
    }
  }
`;
export default OBJECT_IN_A_SENTENCE_ACTIVITY_FRAGMENT;
